import { Button } from '@gto/ui/button'
import { ArrowPathIcon } from '@gto/ui/icons/solid'

import {
  type DataTableStateCopy,
  DEFAULT_ERROR_MESSAGE,
  DEFAULT_RETRY_LABEL,
  StateOverlay,
} from './state-overlay'

export type ErrorStateProps = {
  onRetry?: () => void
  copy?: DataTableStateCopy
}

/**
 * First-class error overlay with a retry affordance. Retry re-runs the query; a
 * successful retry clears `isError` so this overlay unmounts (no stuck/doubled overlay).
 */
export const ErrorState = ({ onRetry, copy }: ErrorStateProps) => (
  <StateOverlay data-table-state="error">
    <span className="text-sm text-error-main">{copy?.errorMessage ?? DEFAULT_ERROR_MESSAGE}</span>
    {onRetry !== undefined && (
      <Button
        size="small"
        startIcon={<ArrowPathIcon />}
        variant="contained"
        onClick={onRetry}
      >
        {copy?.retryLabel ?? DEFAULT_RETRY_LABEL}
      </Button>
    )}
  </StateOverlay>
)
